// extracted by mini-css-extract-plugin
module.exports = {"overlayClass":"loadingIndicator_overlayClass__2SWoB","spinnerClass":"loadingIndicator_spinnerClass__1LVvz"};